export default __webpack_public_path__ + "static/media/hero.996a7acb.mp4";